/**
 * Helpers puros de apresentação da guia Gerenciar envios (Design.md §5).
 * Sem React/DOM — testáveis em node.
 */
export const MARKETPLACE_UK = "A1F83G8C2ARO7P";

const MARKETPLACE_LABELS: Record<string, string> = {
  [MARKETPLACE_UK]: "Amazon UK"
};

/**
 * "Enviar para" (§5.4) derivado de destinationMarketplaces (dado real do
 * PlanDto). Sem marketplace → "—"; vários → "Vários destinos"; um → rótulo
 * conhecido ou o próprio id. Os códigos de FC (LBA4/XLP1) só existem pós-placement
 * em shipments.destinationFcCode — não no nível da lista.
 */
export function deriveDestinationLabel(
  marketplaces: readonly string[]
): string {
  if (marketplaces.length === 0) {
    return "—";
  }
  if (marketplaces.length > 1) {
    return "Vários destinos";
  }
  const id = marketplaces[0] ?? "";
  return MARKETPLACE_LABELS[id] ?? id;
}

export interface PaginationInfo {
  page: number;
  canPrev: boolean;
  canNext: boolean;
}

/**
 * Estado de paginação a partir de offset/limit e da contagem retornada. O
 * backend não devolve total, então "próxima" é habilitada quando a página veio
 * cheia (count >= limit) — sem fabricar números de página finais.
 */
export function paginationInfo(
  offset: number,
  limit: number,
  returnedCount: number
): PaginationInfo {
  const page = limit > 0 ? Math.floor(offset / limit) + 1 : 1;
  return {
    page,
    canPrev: offset > 0,
    canNext: limit > 0 && returnedCount >= limit
  };
}

/** Data/hora em pt-BR; mantém o ISO se inválido. */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString("pt-BR");
}

/**
 * Sufixo " | ID de referência" da coluna "Nome da remessa" (§5.4). Só aparece
 * quando há spApiInboundPlanId e ele difere do id interno (evita "id | id" em
 * planos DRAFT, que ainda não têm id da Amazon).
 */
export function referenceSuffix(
  spApiInboundPlanId: string | undefined,
  internalId: string
): string {
  if (
    spApiInboundPlanId === undefined ||
    spApiInboundPlanId.length === 0 ||
    spApiInboundPlanId === internalId
  ) {
    return "";
  }
  return ` | ${spApiInboundPlanId}`;
}
